export interface IDrawnTileAppearanceInput {
  readonly baseAlpha: number;
  readonly tileId: number;
  readonly drawnTileId?: number;
  readonly fadeInDrawnTile: boolean;
}

/** 只有本次新摸進的牌從透明開始；同一次重繪中的其餘手牌維持原透明度。 */
export const drawnTileInitialAlpha = ({
  baseAlpha,
  tileId,
  drawnTileId,
  fadeInDrawnTile,
}: IDrawnTileAppearanceInput): number =>
  fadeInDrawnTile && tileId === drawnTileId ? 0 : baseAlpha;
